export default {"src":"/_next/static/media/three-down-arrow.48c9bc8f.svg","height":28,"width":28,"blurWidth":0,"blurHeight":0};